import { FC, SVGProps } from "react";

const Close: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="243"
      height="243"
      viewBox="0 0 243 243"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M49 112L106.5 169.5L198 78" stroke="white" fill="none" strokeWidth="22" />
      <circle cx="121.5" cy="121.5" r="117" stroke="white" fill="none" strokeWidth="9" />
    </svg>
  );
};

export default Close;
